<footer class="w-full px-4 py-8 text-sm text-white sm:px-20 bg-primary-800">
  <div class="container flex justify-between mx-auto">
    <div>
      <p>&copy; {{ company }}</p>
    </div>
  </div>
</footer>
